export const IDENTIFIER_PROP = 'identifier'
export const NEW_PASSWORD_PROP = 'password'
export const RESET_PASSWORD_URL = 'hefty/password/reset'

export const POST_EULA_STATUS = 'POST_EULA_STATUS'
export const ACCEPT_EULA = 'ACCEPT_EULA'
export const CHECK_EULA_STATUS = 'CHECK_EULA_STATUS'
export const CHECK_EULA_URL = 'client/get-eula/'
export const ACCEPT_EULA_URL = 'client/sign-eula/'

export const EFFECTIVE_DATE = '2018-06-01'
